/** Plain textarea ↔ HTML storage for line-by-line instructions. */

const MAX_PLAIN_LEN = 500;

export function getStorageInstructionsPlainMax() {
  return MAX_PLAIN_LEN;
}

function escapeHtml(text) {
  return String(text ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function unescapeHtml(text) {
  return String(text ?? "")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&");
}

/** Convert textarea plain text (with newlines) to safe HTML with <br />. */
export function plainTextToStorageHtml(text) {
  const normalized = String(text ?? "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .trim();
  if (!normalized) return null;
  return escapeHtml(normalized).split("\n").join("<br />");
}

/** Convert stored HTML (or legacy plain) back to textarea plain text. */
export function storageHtmlToPlainText(html) {
  let s = String(html ?? "");
  if (!s) return "";
  s = s
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>\s*<p[^>]*>/gi, "\n")
    .replace(/<\/?p[^>]*>/gi, "")
    .replace(/<\/div>/gi, "\n")
    .replace(/<[^>]+>/g, "");
  return unescapeHtml(s).replace(/\n{3,}/g, "\n\n").trimEnd();
}

export function validateStorageInstructionsPlain(text) {
  const plain = String(text ?? "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  if (plain.trim().length === 0 && plain.length > 0) {
    return "Storage instructions cannot be whitespace only.";
  }
  if (plain.length > MAX_PLAIN_LEN) {
    return `Storage instructions cannot exceed ${MAX_PLAIN_LEN} characters.`;
  }
  return "";
}
